import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux'
import {Uploader} from '../../components/uploader/Uploader'
import {manualUploadAPI} from '../../../api/manualupload/manualUploadAPI'
import Alert from 'react-popup-alert'
//import Modal, { useModalState } from "react-simple-modal-provider";

function FileUploaderContainer({setDataGrid}) {



     const [alert, setAlert] = React.useState({
         type: 'error',
         text: 'Tracciato non valido.',
         show: false
       })

       function onCloseAlert() {
         setAlert({
           type: '',
           text: '',
           show: false
         })
       }
    
       function onShowAlert(type) {
         setAlert({
           type: type,
           text: 'Tracciato non valido.',
           show: true
         })
       }

   const voidRecord = [];
   const [data, setData] = useState(voidRecord);

    const onFileAdded = (binaryStr, fileName) => {

      var code = window.sessionStorage.getItem('code');

        manualUploadAPI.importFile(binaryStr, "", fileName, code , res => {
          

            if (!res || res.length === 0) setData(voidRecord);
            else if (res === "Tracciato non valido"){
                onShowAlert('error');
               
            }
            else setDataGrid(res);
                //   this.setState(this.state.values);
                // else {
                //   var values = this.state.values;
                //   values.esito = res[0].esito;
                //   values.isValid = res[0].isvalid;
                //   this.setState({ values: values });
               // }

        })
    }

    return (<>
        
        <Uploader onFileAdded={onFileAdded} />
        
        
        <div style={{ display: 'flex', justifyContent: 'center', marginTop:0 }}>

         <Alert
        header={'Errore'}
        btnText={'Close'}
        text={alert.text}
        type={alert.type}
        show={alert.show}
        onClosePress={onCloseAlert}
        pressCloseOnOutsideClick={true}
        showBorderBottom={true}
        alertStyles={{}}
        headerStyles={{fontSize:25}}
        textStyles={{fontSize:20}}
        buttonStyles={{}}
      />
      </div>
    </>);
}

export const FileUploader = connect(null, null)(FileUploaderContainer)